import React from "react";
import { motion } from "framer-motion";

const Socm = [
  {
    icon: "./imgs/fb.svg",
    url: "facebook.com",
  },
  {
    icon: "./imgs/in.svg",
    url: "instagram.com",
  },
];

export default function NavTop() {
  return (
    <motion.div
      variants={{
        hidden: { top: "-100px" }, // Moves it left
        visible: { top: "0" }, // Adjust as needed
      }}
      initial="hidden"
      animate="visible"
      transition={{ duration: 0.7, delay: 0.6 }}
      className="backdrop-filter backdrop-blur-[10px] gap-[15px] z-[100] fixed top-0 left-[60px] right-0 bg-[#0a0a0d] bg-opacity-50 min-h-[80px] pl-[30px] flex items-center"
    >
      {Socm.map((link, index) => (
        <a href={link.url} key={index}>
          <img
            className="max-w-[25px] opacity-70 hover:opacity-100 [transition:all_ease_0.3s]"
            alt={`Icon no ${index}`}
            src={link.icon}
          ></img>
        </a>
      ))}
      <a
        href="tel:"
        className="text-white flex gap-[5px] ml-[25px] opacity-80 hover:opacity-100 [transition:all_ease_0.3s]"
      >
        <img
          alt="phone icon"
          src="./imgs/phone.svg"
          className="max-w-[25px]"
        ></img>
        +38268555333
      </a>
    </motion.div>
  );
}
